/* PURE reviews wall v2: filter pills toggle reviews by data-tags; data-limit caps how many show per
   filter, with a "Show more" button for the rest. No dependencies. Without JS every review shows. */
if (!window.customElements.get('pv-reviews-wall')) {
  window.customElements.define(
    'pv-reviews-wall',
    class PvReviewsWall extends HTMLElement {
      connectedCallback() {
        this.group = this.querySelector('.pv-reviews__filters');
        this.cards = Array.from(this.querySelectorAll('.pv-reviews__card'));
        this.status = this.querySelector('[data-status]');
        this.more = this.querySelector('[data-more]');
        this.limit = parseInt(this.dataset.limit, 10) || 0;
        this.expanded = false;
        if (this.cards.length === 0) return;

        this.chips = this.group ? Array.from(this.group.querySelectorAll('[data-filter]')) : [];
        if (this.chips.length > 1) {
          this.group.hidden = false;
          this.group.addEventListener('click', (event) => {
            const chip = event.target.closest('[data-filter]');
            if (chip) {
              this.expanded = false;
              this.apply(chip, true);
            }
          });
        }

        if (this.more) {
          this.more.addEventListener('click', () => {
            this.expanded = true;
            this.apply(this.activeChip(), true);
          });
        }

        this.apply(this.activeChip(), false);
      }

      activeChip() {
        return this.chips.find((c) => c.getAttribute('aria-pressed') === 'true') || null;
      }

      apply(chip, announce) {
        const filter = chip ? chip.dataset.filter : 'all';
        let matched = 0;
        let shown = 0;
        this.chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
        this.cards.forEach((card) => {
          const tags = ' ' + (card.dataset.tags || '') + ' ';
          const match = filter === 'all' || tags.indexOf(' ' + filter + ' ') !== -1;
          let visible = match;
          if (match) {
            matched += 1;
            if (this.limit > 0 && !this.expanded && matched > this.limit) visible = false;
          }
          card.hidden = !visible;
          if (visible) shown += 1;
        });
        if (this.more) this.more.hidden = !(this.limit > 0 && !this.expanded && matched > this.limit);
        if (announce && this.status) {
          this.status.textContent =
            filter === 'all'
              ? 'Showing ' + shown + ' of ' + matched + ' reviews'
              : 'Showing ' + shown + ' of ' + matched + ' reviews about ' + chip.textContent.trim();
        }
      }
    }
  );
}
